import { Autocomplete, Box, Button, Checkbox, CircularProgress, Modal, TextField } from '@mui/material'
import { useContext, useEffect } from 'react'
import { ToolContext } from '../../../core/context/ToolContext'
import { rqx } from '../../../core/request/API';
import { env } from '../../../core/Env';
import { ValidateInt } from '../../../core/validator/Validator'
import { SnakeLoader } from '../../../core/loader/SnakeLoader'

export const BankAccount = () => {
    const { personalization_state, tool_state } = useContext(ToolContext)
    const { bankForm, bankList, openBankForm, openTerms, agreedTerms, fromNavigation, hasAgreed } = personalization_state
    const { __SESSION, userId } = tool_state

    const handlerOnChange = (e, val) => {
		if (e.target?.name === 'terms') {
			if (agreedTerms.data) {
				agreedTerms.set(e.target.checked)
			} else {
				handleOpenTermsOfUse()
			}
		} else if (val !== undefined) {
            const value = val === null ? '' : val.id
            bankForm.set({...bankForm.data, bank_id: value})
        } else {
            const { name, value, checked } = e.target
            bankForm.set({...bankForm.data, [name]: name === 'agree' ? checked : value})
        }
    }
    
    const handlerSave = async() => {
        if (!bankForm.data.saving) {
            if (bankForm.data.company_name === '' || bankForm.data.bank_id === '' || bankForm.data.account_name === '' || bankForm.data.account_number === '') {
                bankForm.set({...bankForm.data, error : true})
            }else{
                bankForm.set({...bankForm.data, error : false, saving: true})
                console.log('saving....')
                const body = {
                    company_name: bankForm.data.company_name,
                    company_id: __SESSION.data.uaccess[0].company_id,
                    bank_id: bankForm.data.bank_id,
                    account_name: bankForm.data.account_name,
                    account_number: bankForm.data.account_number,
                    user_id: userId.data
                }
                let res_biz = await rqx.post(`<<biz>>/${env()}/biz/bank/create`, body)
                if (res_biz.message === 'success') {
                    bankForm.set({...bankForm.data, saving : false})
                    openBankForm.set(false)
                }
            }
        }
    }
	
	const handleSubmit = async () => {
		if ((bankForm.data.agree && !bankForm.data.disabled) && (agreedTerms.data && !hasAgreed.data)) {
			if (!bankForm.data.saving) { // SAVE BOTH
				if (bankForm.data.company_name === '' || bankForm.data.bank_id === '' || bankForm.data.account_name === '' || bankForm.data.account_number === '') {
					bankForm.set({...bankForm.data, error : true})
				}else{
					bankForm.set({...bankForm.data, error : false, saving: true})
					const body = {
						company_name: bankForm.data.company_name,
						company_id: __SESSION.data.uaccess[0].company_id,
						bank_id: bankForm.data.bank_id,
						account_name: bankForm.data.account_name,
						account_number: bankForm.data.account_number,
						user_id: userId.data
					}
					const bodyTerms = {
						company_id: tool_state.__SESSION.data.uaccess[0].company_id,
						user_id: tool_state.userId.data,
						tool_id: process.env.REACT_APP_TID_BIZ,
						type: 2,
						agree: 1,
						active: 1,
						data_status: "InUse"
					}
					let res_biz = await rqx.post(`<<biz>>/${env()}/biz/bank/create`, body)
					const res_terms = await rqx.post(`<<tool>>/${env()}/user/create_terms_agree`, bodyTerms)
					if (res_biz.message === 'success' && res_terms.message === 'success') {
						bankForm.set({...bankForm.data, saving : false})
						openBankForm.set(false)
					}
				}
        	}
		} else if (bankForm.data.agree && !bankForm.data.disabled) {
			await handlerSave(); // SAVE BANK TERMS ONLY
		} else if (agreedTerms.data && !hasAgreed.data) {
			try { // SAVE TERMS OF ONLY
				bankForm.set({...bankForm.data, error : false, saving: true})
				const body = {
					company_id: tool_state.__SESSION.data.uaccess[0].company_id,
					user_id: tool_state.userId.data,
					tool_id: process.env.REACT_APP_TID_BIZ,
					type: 2,
					agree: 1,
					active: 1,
					data_status: "InUse"
				}
				const res = await rqx.post(`<<tool>>/${env()}/user/create_terms_agree`, body)
				if (res.message === 'success') {
                    bankForm.set({...bankForm.data, saving : false})
                    openBankForm.set(false)
				}
			} catch (error) {
				console.log(error);
			}
		} 
	}
    
	const handleOpenTermsOfUse = () => {
		openBankForm.set(false)
		openTerms.set(true)
		fromNavigation.set(false)
	}
	
	const handleGenerateBank = () => {
		const bank = bankList.data.find(v => v.id === bankForm.data.bank_id)
		return bank || null
	}

    useEffect(() => {
        const read = async() => {
            const res = await rqx.get(`<<biz>>/${env()}/biz/bank/read`)
            const c = await rqx.get(`<<biz>>/${env()}/general-maintenance/company/company-setup/getByCompanyId`, {company_id: __SESSION.data.uaccess[0].company_id})
			const r = await rqx.get(`<<biz>>/${env()}/biz/bank/readBank`, {company_id: __SESSION.data.uaccess[0].company_id})
            bankList.set(res)
            bankForm.set({...bankForm.data, company_name: c[0]?.name, bank_id: r[0]?.bank_id || "", account_name: r[0]?.account_name || "", account_number: r[0]?.account_number || "", loader : false, has_company_name: Boolean(c[0]?.name)})
        }
        
        read()
        // eslint-disable-next-line
    }, [])
	
    return (
        <Modal open={openBankForm.data}>
            <Box height="100%" width="100%" display="flex" justifyContent="center" alignItems="center">
                <Box display="flex" flexDirection="column" bgcolor={bankForm.data.saving ? "#eeeeee" : "#fff"}  p={3} borderRadius={3} width={500 } gap="16px">
                    {
                        bankForm.data.loader ?
                            <Box height={470} display="flex" alignItems="center" justifyContent="center"> 
                                <CircularProgress />
                            </Box>
                        :
                        <>
                            <Box fontSize={14} fontWeight={600} textAlign="justify">
                        {/* We have recorded your sales.  */}
                                Please set up your bank details so POFSIS can transfer the payment for your products or services to your account.
                            </Box>
                            <Box display="flex" flexDirection="column" gap="8px">
                                <Box>
                                    <Box fontSize={14} fontWeight={600}>Company Name</Box>
                                    <TextField name="company_name" size='small' fullWidth onChange={(e) => handlerOnChange(e)}
                                        value={bankForm.data.company_name}
                                        error={bankForm.data.company_name === '' && bankForm.data.error}
                                        disabled={bankForm.data.saving || bankForm.data.disabled || bankForm.data.has_company_name}
                                    />
                                </Box>
                                <Box>
                                    <Box fontSize={14} fontWeight={600}>Bank Name</Box>
                                    {/* <TextField name="bank_name" size='small' fullWidth onChange={(e) => handlerOnChange(e)}/> */}
                                    <Autocomplete
                                        options={bankList.data}
                                        getOptionLabel={(val) => val.name}
                                        onChange={ (e, newValue) => { handlerOnChange('', newValue)}}
										value={handleGenerateBank()}
                                        disabled={bankForm.data.saving || bankForm.data.disabled}
                                        renderInput={(params) => (
                                            <TextField
                                            {...params}
                                            variant="outlined"
                                            size='small'
                                            error={bankForm.data.bank_id === '' && bankForm.data.error}
                                            />
                                        )}
                                        />
                                </Box>
                                <Box>
                                    <Box fontSize={14} fontWeight={600}>Account Name</Box>
                                    <TextField name="account_name" size='small' fullWidth onChange={(e) => handlerOnChange(e)}
										value={bankForm.data.account_name}
                                        error={bankForm.data.account_name === '' && bankForm.data.error}
                                        disabled={bankForm.data.saving || bankForm.data.disabled}
                                    />
                                </Box>
                                <Box>
                                    <Box fontSize={14} fontWeight={600}>Account Number</Box>
                                    <TextField name="account_number" size='small' fullWidth onChange={(e) => handlerOnChange(e)}
										value={bankForm.data.account_number}
                                        error={bankForm.data.account_number === '' && bankForm.data.error}
                                        onKeyPress={(e) => ValidateInt(e)}
                                        disabled={bankForm.data.saving || bankForm.data.disabled}
                                    />
                                </Box>
                            </Box>
                            <Box fontSize={12} fontWeight={600} textAlign="center">
                                Terms and Conditions for Bank Account Details
                            </Box>
                            <Box display="flex" alignItems="center" textAlign="justify">
                                <Checkbox name='agree' checked={bankForm.data.disabled || bankForm.data.agree} onChange={(e) => handlerOnChange(e)} disabled={bankForm.data.disabled}/>
                                <Box fontSize={12} fontWeight={600}>
                                    I confirm that the bank account details provided are accurate and authorize {bankForm.data.company_name} to use them for processing payments related to my transactions.
                                </Box>
                            </Box>
							<Box display="flex" alignItems="center" textAlign="justify">
                                <Checkbox name='terms' checked={agreedTerms.data} onChange={(e) => handlerOnChange(e)} disabled={agreedTerms.data && hasAgreed.data}/>
                                <Box fontSize={12} fontWeight={600}>
                                    I agree to the <Box component='span' onClick={handleOpenTermsOfUse} sx={{ textDecoration: 'underline', cursor: 'pointer', fontStyle: 'italic' }}>POFSIS Merchant Terms of Use</Box> and authorize applicable deductions.
                                </Box>
                            </Box>
                            <Box fontSize={12} fontWeight={600} textAlign="center" color="#f44336">
                                Note: By clicking 'Save' you confirm that the above data is correct and authorize POFSIS to transfer your sales to this account.
                            </Box>
                            <Box display="flex" alignItems="center" justifyContent="center" gap="16px">
                                <Box component={Button} height={36} width={130} onClick={() => openBankForm.set(false)}
                                    disabled={bankForm.data.saving}
                                >
                                    Remind me Later
                                </Box>
                                <Box component={Button} variant="contained" height={36} width={130} disableElevation onClick={() => handleSubmit()}
                                    disabled={!((bankForm.data.disabled && agreedTerms.data) || bankForm.data.agree || (agreedTerms.data && !hasAgreed.data))}>
                                    {bankForm.data.saving ? <SnakeLoader bg="#fff" size="10px" distance="10px" /> : 'Save'}
                                </Box>
                            </Box>
                        </>
                    }
                </Box>
            </Box>
        </Modal>
    )
}
